// api/v1/categories.ts
import { createPath } from '../_utils/createPath';
import { api } from '../api';

export const categories = {
  getAll: createPath('/categories/'),
};

export interface Category {
  id: number;
  name: string;
  title?: string;
  slug?: string;
  subcategories: Subcategory[];
}

export interface Subcategory {
  id: number;
  name: string;
  title?: string;
  slug?: string;
}

export const getCategories = async (): Promise<Category[]> => {
  const response = await api.get(categories.getAll);
  return response.data;
};
